import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Box, Tabs, Text } from '@mantine/core';
import { IconActivity, IconAdjustments, IconCoin } from '@tabler/icons-react';
import { VariablesServiciosCV } from './tabs/variablesServiciosCV';
import { CostosBaseServiciosCV } from './tabs/costosBaseServiciosCV';
import { CatalogosServiciosCV } from './tabs/catalogosServiciosCV';

/** Encabezado y pestañas de la configuración; cada pestaña tiene su propio controlador (igual que NBS). */
export const ConfiguracionServiciosCV: React.FC = () => {
    const [pestanaActiva, setPestanaActiva] = useState<string | null>('variables');

    // Una sola fila en edición entre todas las tablas: al editar otra (o cambiar de pestaña) se cancela la actual.
    const canceladoresRef = useRef<Record<string, () => void>>({});
    const registrarCancelacion = useCallback((clave: string, cancelar: () => void) => {
        canceladoresRef.current[clave] = cancelar;
    }, []);
    const cancelarTodasLasEdiciones = useCallback(() => {
        Object.values(canceladoresRef.current).forEach(cancelar => cancelar());
    }, []);
    useEffect(() => () => cancelarTodasLasEdiciones(), [cancelarTodasLasEdiciones]);

    const coordinacion = { onRegistrarCancelacion: registrarCancelacion, onIniciarEdicionGeneral: cancelarTodasLasEdiciones };

    return (
        <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', height: '100%' }}>
            <Box
                pb="md"
                pt="md"
                style={{
                    flexShrink: 0,
                    position: 'sticky',
                    top: 0,
                    zIndex: 10,
                    backgroundColor: 'var(--mantine-color-body)',
                    paddingLeft: '20px',
                    paddingRight: '20px'
                }}
            >
                <Text fw={700} size="lg">Configuración</Text>
                <Text c="dimmed" size="xs">Parámetros Comerciales Servicios</Text>
            </Box>

            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '0 20px 20px 20px' }}>
                <Tabs
                    value={pestanaActiva}
                    onChange={(valor) => { setPestanaActiva(valor); cancelarTodasLasEdiciones(); }}
                    style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
                >
                    <Tabs.List mb="md">
                        <Tabs.Tab value="variables" leftSection={<IconAdjustments size={14} />}>Tarifas y Variables</Tabs.Tab>
                        <Tabs.Tab value="costos" leftSection={<IconCoin size={14} />}>Costos e Incrementos</Tabs.Tab>
                        <Tabs.Tab value="catalogos" leftSection={<IconActivity size={14} />}>Catálogos y Factores</Tabs.Tab>
                    </Tabs.List>

                    <Tabs.Panel value="variables" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
                        {pestanaActiva === 'variables' && <VariablesServiciosCV />}
                    </Tabs.Panel>
                    <Tabs.Panel value="costos" style={{ flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' }}>
                        {pestanaActiva === 'costos' && <CostosBaseServiciosCV {...coordinacion} />}
                    </Tabs.Panel>
                    <Tabs.Panel value="catalogos" style={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
                        {pestanaActiva === 'catalogos' && <CatalogosServiciosCV {...coordinacion} />}
                    </Tabs.Panel>
                </Tabs>
            </div>
        </div>
    );
};
